export default __webpack_public_path__ + "static/media/InterFontIcons.c11b31ff.woff";